module.exports = "<div ng-if=restrictUi.asInternalFeature()> What is your current setup in regards to travel [reimbursements]? ... i need to file travel claims after I have been on business trips, and I travel ... once or twice a year ... 2-10 times a year ... all the time to do this is x important... today I do this by .... and I am y satisfied with my current/previous solution... </div>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/current-setup-travel-reimbursements.html
// module id = 1717
// module chunks = 86